import { Injectable } from '@angular/core';

import { I18nService } from '@recruitee/i18n';
import { getHumanReadableFileSize, MaxFileSize } from '@recruitee/utils';

import { NotificationsController } from '../../notifications/notifications.controller';

@Injectable({ providedIn: 'root' })
export class FileNotificationService {
  constructor(
    private notify: NotificationsController,
    private i18n: I18nService,
  ) {}
  public notifySizeExceeded(file: File, maxFileSize: MaxFileSize): void {
    this.notify.error(
      this.i18n.translate('app.common.errors.file_size_limit_exceeded', {
        limit: getHumanReadableFileSize(maxFileSize),
        fileSize: getHumanReadableFileSize(file?.size ?? 0),
      }),
    );
  }

  public notifyInvalidExtension(): void {
    this.notify.error(this.i18n.translate('app.common.errors.unsupported_file'));
  }
}
